import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";

import { bookEditingImg2 } from "../../asserts/images";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const BookEditing = () => {
  return (
    <>

    <Helmet>
        <meta charSet="utf-8" />
        <title>
            Best Book Editors | Hire Book Editing Services in the USA
        </title>
        <meta
          name="description"
          content="Hire the best book editors in the USA with Falcon Book Writing to polish your manuscript, improve readability, and create a professional, publish-ready book."
        />
        <meta name="keywords" content="Best Book Editors" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


      <UserLayout>
        <InnerHero
          innerheroclass="bookEditingBg"
          // title="Let Your Story Be Heard, Beautifully"
          subtitle=" Expert Editing"
          title2="That Perfects Every Chapter of Your Book"
          para="Refine your manuscript with expert editing that enhances clarity, sharpens your voice, and ensures every chapter flows seamlessly. Our editors focus on structure, style, and precision, transforming your draft into a compelling read. For a complete publishing-ready book, we also offer 
                book formatting to make your work truly professional and polished."
        />


        <Section2
          innerSec2Class="innerbrilliant_mind_section"
          title="Perfect Grammar, Style, and Structure for   "
          subtitle=" Maximum Impact"
          // title2="Your Narrative"
          // subtitle1="How we work?"
          description="A polished manuscript can turn a good story into an unforgettable experience. Our expert editors refine every sentence, perfect grammar, enhance style, and ensure seamless structure, making your narrative captivating from start to finish. We preserve your unique voice while elevating clarity and readability, so your book leaves a lasting impression. To complement our editing, we also provide ghostwriting services, offering professional support to bring your ideas to life and create a manuscript that’s not only flawless but fully ready to impress readers and stand out in the publishing world."

          // subtitle2="    Tailored Collaborations?"
          // subtitle3="  Expert Guidance"
          image={bookEditingImg2}
          imgClass="bookEditingImg2"
          actions={true}
          btn1="Let’s Get Start"
          btn2="Call Us Now"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default BookEditing;
